import { useState } from "react";
import ModalBasic from "Components/Modal/Modal";
import { ReactComponent as RefundIcon } from "Assets/Refund.svg";
import { InputField } from "Components/Common/InputField/InputField";
import { ReactComponent as DollarIcon } from "Assets/Dollar.svg";
import "Colors.css";

export const RefundModal = ({
  isModalOpen,
  isLoading,
  onRefund,
  onCancel,
  setRefundAmount,
  amount,
  cart = [],
}) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [inputValue, setInputValue] = useState("");

  const onFullRefund = () => {
    setInputValue(String(amount));
    setRefundAmount(amount);
    setIsDisabled(false);
  };

  return (
    <ModalBasic
      icon={<RefundIcon />}
      btnText="Confirm Refund"
      heading="Refund Payment"
      content="A refund will be issued to the patient within a few days"
      open={isModalOpen}
      isDisabled={isDisabled}
      loading={isLoading}
      setOpen={(value) => {
        if (value === "Confirm Refund") {
          onRefund();
        } else {
          onCancel();
        }
      }}
    >
      {cart.length > 0 && (
        <div className="border border-gray-200 rounded-md divide-y divide-gray-200 mb-4 text-sm">
          {cart.map((item, index) => (
            <div key={index} className="flex justify-between px-3 py-2">
              <span className="sapphire">{item?.name || "Item"}</span>
              <span className="light_grayish_navy">${item?.price ?? "-"}</span>
            </div>
          ))}
          <div className="flex justify-between px-3 py-2 font-semibold">
            <span className="sapphire">Total charged</span>
            <span className="sapphire">${amount}</span>
          </div>
        </div>
      )}
      <InputField
        id="payment"
        type="number"
        placeholder="amount"
        isRequired={true}
        value={inputValue}
        onChange={(refundAmount, setInputFieldError) => {
          if (refundAmount > amount) {
            setInputFieldError(
              `Please enter the correct refund amount ${amount}`
            );
            setIsDisabled(true);
          } else if (refundAmount) {
            setRefundAmount(refundAmount);
            setIsDisabled(false);
          } else {
            setIsDisabled(true);
          }
        }}
      >
        <DollarIcon className="w-6 h-6 light_grayish_navy pointer-events-none" />
      </InputField>
      <button
        type="button"
        className="w-full mt-2 text-sm font-medium text-blue-chill border border-gray-200 rounded-md py-2 hover:bg-gray-50"
        onMouseDown={(e) => e.preventDefault()}
        onClick={onFullRefund}
      >
        Full Refund (${amount})
      </button>
    </ModalBasic>
  );
};
